module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Checkout","headerStepCreateAccount":"Crea il tuo account","headerStepDeliveryAddress":"Indirizzo di consegna","headerStepBillingInfo":"Dati di fatturazione"},"en":{"pageTitle":"Checkout","headerStepCreateAccount":"Create your account","headerStepDeliveryAddress":"Delivery Address","headerStepBillingInfo":"Billing Information"}}')
  delete Component.options._Ctor
}
